import {Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import {Subscription} from 'rxjs';

import {FAQViewModel} from '../../viewModels/faq.viewModel';
import {WebsiteService} from '../../../shared/services/website.service';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FAQComponent implements OnInit {
    faqs: FAQViewModel[];
    subscriptions: Subscription[] = [];

    constructor(
        private readonly websiteService: WebsiteService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
    ) {
    }

    ngOnInit() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.subscriptions.push(
            this.websiteService.getFAQ().subscribe(faqs => {
                this.faqs = faqs;

                this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                this.changeDetectorRef.markForCheck();
            })
        );
    }
}
